import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

import { greviencemodel } from '../../models/grevience/grevience.model';
import {IMyDpOptions} from 'mydatepicker';


@Component({
  selector: 'app-request-manage',
  templateUrl: './requestMangement.component.html'
})
export class requestMangementComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public allRequestData : any = [];
  public allCategoryData : any = [];
  public allSubData : any = [];
  public greviencemodel: greviencemodel = new greviencemodel;
  public popupopen : boolean = false;
  public viewpopupopen : boolean = false;
  public viewStatus : string = "";
  public viewDate : any = "";
  public viewDocket : any = "";
  public viewCat : any = "";
  public viewSubCat : any = "";
  public viewDetails : string = "";
   
   public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
		disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth()+1, day: new Date().getDate()-1 }
    };

  constructor(public http: HttpTestService, public session: sessionServices) { }

  ngOnInit() {
	  this.getSession();
	  this.getAllRequest();
	  this.getCategory();
  }
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}
  
  
  getAllRequest = function(){
	var self = this;
	self.http.getRequestdetails()
		  .subscribe(
			(data) => {
			  self.allRequestData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.allRequestData = [];
			},
			() => {}
	);
 }
 
 changeBradcastList = function(e){
	 var self =  this;
	 var selectedType = e.target.value;
	 if(selectedType == "Gen"){
		self.ViewableBroadcastData = self.GenBroadcastData;
	 }else{
		self.ViewableBroadcastData = self.ZonalBroadcastData;
	 }
	 
 }
 
 
 getCategory = function(){
	var self = this;
	self.http.getRequestCats()
		  .subscribe(
			(data) => {
			  self.allCategoryData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.allCategoryData = [];
			},
			() => {}
	);
 }
 
 getSub = function(e){
	 var self = this;
	 self.allSubData = [];
	 self.greviencemodel.grevienceSubCat = "";
	 var selectedRegion = e.target.value;
	 if(selectedRegion != ''){
		 self.allSubData = self.allCategoryData[selectedRegion].sub;
	 }
	 
 }
 
 createUserPopupReset = function(){
	 var self = this;
	 self.greviencemodel.grevienceCat = "";
	 self.greviencemodel.grevienceSubCat = "";
	 self.greviencemodel.grevienceDetails = "";
	 self.viewStatus = "";
	 self.viewDate = "";
	 self.viewDocket = "";
	 self.viewCat = "";
	 self.viewSubCat = "";
	 self.viewDetails = "";
}
 
 openPopup = function(){
	 var self = this;
	 self.createUserPopupReset();
	 self.popupopen = true;
 }
 
  closePopup = function(){
	 var self = this;
	 self.createUserPopupReset();
	 self.popupopen = false;
	 self.viewpopupopen = false;
 }
 
 getDetails = function(index){
	var self = this;
	self.viewStatus = self.allRequestData[index].status;
	self.viewDate = self.allRequestData[index].date;
	self.viewDocket = self.allRequestData[index].docketno;
	self.viewCat = self.allRequestData[index].catName;
	self.viewSubCat = self.allRequestData[index].subCatName;
	self.viewDetails = self.allRequestData[index].msg;
	self.viewpopupopen = true;
 }


}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/request/requestMangement.component.ts